import { render } from "./OrderList.vue?vue&type=template&id=2f0b0118"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=2f0b0118&lang=css"
script.render = render

export default script